import React, {Component} from "react";
import PropTypes from 'prop-types';

import {XButton, XDiv, XSpan} from "../Layout/Layout";

class  Navbar extends Component{

    constructor(props) {
        super(props);

        this.isAlive = true;

        this.state = {open:false};
        this.bClick=this.clicked.bind(this);
        this.props=props;
    }

    clicked(event) {
        event.preventDefault();
        event.stopPropagation();
        if(this.state.open){
            this.setState({open:false});
        }else{
            this.setState({open:true});
        }
        return false;
    }

    render() {
        const {
            children,
            className,
        } = this.props;

        let c=`navbar navbar-expand-sm   ${className}`;
        let collapseClass="";
        if ( this.state.open ){
            collapseClass="collapse navbar-collapse show";
        }else{
            collapseClass="collapse navbar-collapse ";
        }

        return (
            <React.Fragment>
                <XDiv className={c}  >
                    <XButton className="navbar-toggler" type="button" onClick={this.bClick}>
                        <XSpan className="navbar-toggler-icon la la-navicon"></XSpan>
                    </XButton>
                    <XDiv className={collapseClass}>
                        {children}
                    </XDiv>
                </XDiv>
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Navbar.propTypes = {
    className: PropTypes.string,
};

Navbar.defaultProps = {
    className:"navbar-default"
};

export default Navbar;